import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
} from 'recompose';
import { StandardModal } from '@ux/modal';
import { FormattedMessage } from 'react-intl';
import Negotiate from './ConnectedNegotiate';
import { withStyles } from '@ux/style-utils';
import { withBreakpoints } from '@ux/responsive';
import stylesheet from './Modal.stylesheet';
import * as r from 'ramda';

export const PureNegotiateModal = ({
  theme,
  actions,
  options,
  currency,
  fqdn,
  styles,
}) => (
  <StandardModal
    theme={theme}
    titleText={(
      <div style={styles.header}>
        <span style={styles.title}>
          <FormattedMessage id="dst.negotiate.v2.title"/>
        </span>
        <If condition={fqdn}>
          <span style={styles.fqdn}>
            {fqdn}
          </span>
        </If>
      </div>
    )}
    actions={actions}
    component={(
      <Negotiate
        fqdn={fqdn}
        theme={theme}
        actions={actions}
        price={options.price}
        currency={currency}
        showLegalTerms={options.showLegalTerms}
      />
    )}
  />
);

export const enhance = compose(
  setDisplayName('NegotiateModal'),
  withProps((props) => ({
    fqdn: r.pathOr(null, [ 'actions', 'params', 'fqdn' ], props),
  })),
  withBreakpoints,
  withStyles(stylesheet),
);

export default enhance(PureNegotiateModal);
